import { dataTreasureChestSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTreasureChestSolid = /*#__PURE__*/createIcon(dataTreasureChestSolid)
export default IconTreasureChestSolid
